import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'lin-cell-link',
  template: `
    <a [routerLink]="routerLink" [queryParams]="queryParams">
      <p class="text-truncate"><ng-content></ng-content></p>
    </a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkCellComponent {
  @Input() routerLink: string | any[]
  @Input() queryParams: { [k: string]: any }
}
